module.exports = __webpack_public_path__ + "img/rt_logo.56ed20d5.png";